import React from 'react';
import TimePicker from 'rc-time-picker';
import 'rc-time-picker/assets/index.css';
import './styles/_xs.css';



const DLTimePicker = function( props ) {
    return (
        <TimePicker allowEmpty={ false } { ...props } />
    );
};

export default DLTimePicker;
